import { Group } from "@mantine/core"

import type { OperationNodeDto } from "~/gen/api"
import { HorizontalDivider } from "~/pages/Brand/Products/Details/TraceabilityGraph/Divider.tsx"
import { SupplierCard } from "~/pages/Brand/Products/Details/TraceabilityGraph/SupplierCard.tsx"

type Props = {
  node: OperationNodeDto
  hideFirstDivider?: boolean
}

export const TraceabilityTreeBranch = ({
  node,
  hideFirstDivider = false,
}: Props) => {
  const operation =
    node.operation !== "not-entered-yet" ? node.operation : undefined

  return (
    <Group key={node.id} gap={0} align="flex-start" wrap="nowrap">
      {!hideFirstDivider && <HorizontalDivider />}
      <SupplierCard
        activityName={node.activityName}
        itemReference={node.reference}
        operation={operation}
      />
    </Group>
  )
}
